<app-illustration-message [iconName]="iconName"
                          [circleColor]="circleColor"
                          [title]="title"
                          [caption]="caption">
</app-illustration-message>
